"use client";

import { CheckIcon, ChevronLeftIcon, InfoIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Heading, Link, Text } from "@chakra-ui/react";
import RouterLink from "next/link";
import { ReactNode } from "react";
import { ContentfulImage } from "../../../components/ContentfulImage";
import { getRichTextRenderFunction } from "../../../utils/renderRichText";

import type { ContentEvent } from "../../content";

const renderRichText = getRichTextRenderFunction(4);

type Props = {
  event: ContentEvent;
  enrolCount: number;
};

export function PageComponent(props: Props): ReactNode {
  const isEnrol =
    props.event.status === "enrol" || props.event.status === "enrol-internal";

  const isLimitReached =
    "limit" in props.event &&
    typeof props.event.limit === "number" &&
    props.enrolCount >= props.event.limit;

  return (
    <>
      <Heading mb={4}>{props.event.title}</Heading>
      <Link as={RouterLink} href="/termine" color="blue.500">
        <ChevronLeftIcon />
        zur Übersicht
      </Link>
      {props.event.status === "enrol-soon" ? (
        <Flex p={4} alignItems="center" rounded="md" bg="yellow.200" mt={4}>
          <InfoIcon />
          <Text ml={4}>Die Online-Anmeldung startet bald!</Text>
        </Flex>
      ) : null}
      {isEnrol && !isLimitReached ? (
        <Flex p={4} alignItems="center" rounded="md" bg="green.200" mt={4}>
          <CheckIcon />
          <Flex
            ml={4}
            flexDirection={["column", "row"]}
            alignItems="center"
            justifyContent="space-between"
            flexGrow="1"
          >
            <Text>
              Für dieses Event kannst du dich ganz einfach online anmelden!
            </Text>
            <Button
              as={RouterLink}
              href={`/anmeldung/${props.event.id}`}
              colorScheme="green"
              ml={[0, 4]}
              mt={[1, 0]}
              flexShrink="0"
            >
              zur Anmeldung
            </Button>
          </Flex>
        </Flex>
      ) : null}
      {isEnrol && isLimitReached ? (
        <Flex p={4} alignItems="center" rounded="md" bg="yellow.200" mt={4}>
          <InfoIcon />
          <Text ml={4}>
            Das Limit für die Anzahl der Anmeldungen ist schon erreicht. Die
            Online-Anmeldung ist daher leider nicht mehr möglich.
          </Text>
        </Flex>
      ) : null}
      {props.event.status === "canceled" ? (
        <Flex p={4} alignItems="center" rounded="md" bg="yellow.200" mt={4}>
          <InfoIcon />
          <Text ml={4}>
            Wir müssen die Veranstaltung auf Grund zu geringer Teilnehmeranzahl
            leider absagen.
          </Text>
        </Flex>
      ) : null}
      {props.event.imageUrl ? (
        <Box rounded="lg" mt={4} overflow="hidden">
          <ContentfulImage
            src={props.event.imageUrl}
            alt={props.event.title}
            height={200}
            width={300}
            style={{ width: "100%" }}
          />
        </Box>
      ) : null}
      {renderRichText(props.event.description)}
    </>
  );
}
